import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const { setUser, refresh } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    (async () => {
      const hash = window.location.hash || "";
      const params = new URLSearchParams(hash.replace(/^#/, ""));
      const sid = params.get("session_id");
      if (!sid) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const r = await api.post("/auth/session", { session_id: sid });
        if (setUser) setUser(r.data.user);
        // Clear hash and go to dashboard
        window.history.replaceState({}, "", "/dashboard");
        await refresh();
        navigate("/dashboard", { replace: true, state: { user: r.data.user } });
      } catch (e) {
        console.error("Auth exchange failed", e);
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser, refresh]);

  return (
    <div className="h-screen flex items-center justify-center text-sm text-muted-foreground">
      Signing you in…
    </div>
  );
}
